import { handleActions, createAction } from 'redux-actions';

export const CREATE_AD = createAction('CREATE/AD');
export const CREATE_AD_SUCCESS = createAction('CREATE_AD_SUCCESS');
export const CREATE_AD_FAIL = createAction('CREATE_AD_FAIL');
export const FETCH_INITIAL_FORM_DETAILS = createAction('FETCH_INITIAL_FORM_DETAILS');
export const FETCH_INITIAL_FORM_DETAILS_SUCCESS = createAction('FETCH_INITIAL_FORM_DETAILS_SUCCESS');
export const FETCH_INITIAL_FORM_DETAILS_FAIL = createAction('FETCH_INITIAL_FORM_DETAILS_FAIL');
export const FETCH_AD = createAction('FETCH_AD');
export const FETCH_AD_SUCCESS = createAction('FETCH_AD_SUCCESS');
export const FETCH_AD_FAIL = createAction('FETCH_AD_FAIL');
export const FETCH_ADS = createAction('FETCH_ADS');
export const FETCH_ADS_SUCCESS = createAction('FETCH_ADS_SUCCESS');
export const FETCH_ADS_FAIL = createAction('FETCH_ADS_FAIL');
export const UPDATE_AD = createAction('UPDATE_AD');
export const UPDATE_AD_SUCCESS = createAction('UPDATE_AD_SUCCESS');
export const UPDATE_AD_FAIL = createAction('UPDATE_AD_FAIL');
export const REMOVE_AD = createAction('REMOVE_AD');
export const REMOVE_AD_SUCCESS = createAction('REMOVE_AD_SUCCESS');
export const REMOVE_AD_FAIL = createAction('REMOVE_AD_FAIL');
export const REMOVE_PHOTO = createAction('REMOVE_PHOTO');
export const REMOVE_PHOTO_SUCCES = createAction('REMOVE_PHOTO_SUCCES');
export const REMOVE_PHOTO_FAIL = createAction('REMOVE_PHOTO_FAIL');


const initialState = {
  ad_data: {},
  redirectPromotion: false,
  data: [],
  errors: null,
  total_count: null,
  total_pages: null,
};

const adsReducer = handleActions(
  {
    [CREATE_AD_SUCCESS]: (state, { payload, }) => {
      return { ...state, redirectPromotion: true, ad_data: payload, };
    },
    [UPDATE_AD_SUCCESS]: (state, { payload, }) => {
      return { ...state, redirectPromotion: true, ad_data: payload, };
    },
    [FETCH_INITIAL_FORM_DETAILS_SUCCESS]: (state, { payload, }) => {
      return { ...state, ad_data: payload, };
    },
    [FETCH_AD_SUCCESS]: (state, { payload, }) => {
      return { ...state, ad_data: payload, };
    },
    [FETCH_ADS_SUCCESS]: (state, { payload: { ads, total_count, total_pages, }, }) => {
      return { ...state, data: ads, total_count, total_pages, };
    },
    [FETCH_ADS_FAIL]: (state, { payload: { error, }, }) => {
      return { ...state, errors: error, };
    },
    [REMOVE_PHOTO_SUCCES]: (state, { payload, }) => {
      return { ...state, ad_data: { ...state.ad_data, photos: payload, }, };
    },

  },
  initialState
);

export default adsReducer;
